import * as types from './types';
// eslint-disable-next-line import/no-cycle
import Vue from 'vue';
import { getParseMaterialInfo, transformPrice } from '../../lib/helper';
import api from '@/apis/manage/index';
import request from '@/lib/request';
import { get, last } from 'lodash';

const filterInitial = {
  media: '',
  status: 'all',
  title: '',
  pid: '',
  price: '',
  source: '',
  category: '',
  orderBy: '',
  mediaId: '',
  fromSaas: '',
  state: null,
  tagSort: [],
  tagID: '',
};

export default {
  namespaced: true,
  state: {
    productList: [],
    priCateList: [],
    page: 1,
    count: 10,
    total: 0,
    filter: {
      ...filterInitial,
    },
    mask: {
      isAddGoods: false,
      isEditWeishi: false,
    },
    editItem: {},
    editRowIndex: null,
    activeTabIndex: 0,
    guide: '',
    reset: '',
    loading: false,
    media_type: '',
    media_id: '',
  },
  mutations: {
    [types.SET_MEDIA_INFO](state, {
      mediaType,
      mediaId,
    }) {
      state.media_id = mediaId;
      state.media_type = mediaType;
    },
    [types.SET_PRODUCT_LIST](state, { paginfo: pageInfo, products }) {
      state.productList = products;
      state.total = Number(pageInfo.total);
    },

    /**
      * 参数 rowIndex, 数据表索引值, Number
      * 参数 status, 状态配置, String, 枚举值：init | loading | error | success
      * 参数 msg, 状态消息, String, 默认值 ""
     */
    setProductOperateStatus(state, { rowIndex, status, msg }) {
      const operateStatus = {
        showBtns: false,
        showLoading: false,
        showError: false,
        showSuccess: false,
        msg: msg || '', // 成功或失败的信息提示
      };

      if (status === 'init') {
        operateStatus.showBtns = true;
      }

      if (status === 'loading') {
        operateStatus.showLoading = true;
      }

      if (status === 'error') {
        operateStatus.showBtns = true;
        operateStatus.showError = true;
      }

      if (status === 'success') {
        operateStatus.showSuccess = true;
      }

      const rowData = state.productList[rowIndex];
      rowData.operateStatus = operateStatus;
      state.productList.splice(rowIndex, 1, rowData);
    },

    [types.SET_PRODUCT_LIST_PAGE_NUM](state, { pageNum }) {
      state.page = pageNum;
    },
    [types.SET_PRODUCT_LIST_PAGE_COUNT](state, { pageCount }) {
      state.count = pageCount;
    },
    [types.SET_PRODUCT_FILTER](state, filter) {
      state.filter = {
        ...state.filter,
        ...filter,
      };
    },
    [types.RESET_PRODUCT_FILTER](state) {
      state.filter = {
        ...filterInitial,
      };
    },
    [types.SET_PRIMARY_CATELIST](state, list) {
      state.priCateList = list;
    },
    [types.SHOW_ADD_GOODS_MASK](state) {
      state.mask.isAddGoods = true;
    },
    [types.HIDE_ADD_GOODS_MASK](state) {
      state.mask.isAddGoods = false;
    },
    [types.SHOW_EDIT_MATERIAL_INFO_MASK](state) {
      state.mask.isEditWeishi = true;
    },
    [types.HIDE_EDIT_WEISHI_MASK](state) {
      state.mask.isEditWeishi = false;
    },
    [types.SET_EDIT_ITEM](state, { editItem, editRowIndex }) {
      state.editItem = editItem;
      state.editRowIndex = editRowIndex;
    },
    [types.REMOVE_EDIT_ITEM](state) {
      state.editItem = {};
      state.editRowIndex = null;
    },
    [types.SET_ACTIVE_TAB_INDEX](state, { activeTabIndex }) {
      state.activeTabIndex = activeTabIndex;
    },
    [types.RESET](state) {
      state.filter = {
        ...filterInitial,
        mediaId: state.filter.mediaId,
      };

      state.activeTabIndex = 0;
      state.reset = Date.now();
    },
    SHOW_GUIDE(state) {
      state.guide = Date.now();
    },
    [types.CHANGE_LOADING](state, { loading }) {
      state.loading = loading;
    },
  },
  actions: {
    async fetchProducts({ commit, state }) {
      if (!state.filter.mediaId) return;

      commit(types.CHANGE_LOADING, { loading: true });
      const reqData = {
        title: state.filter.title,
        saas_product_id: state.filter.pid,
        price: transformPrice(state.filter.price),
        source: state.filter.source,
        primary_cate:
          state.filter.category === '全部' ? '' : state.filter.category,
        media: state.filter.media,
        media_id: state.filter.mediaId,
        status: state.filter.status,
        order_by: state.filter.orderBy,
        page: state.page,
        count: state.count,
        tag_cat_id: last(state.filter.tagSort) ? Number(last(state.filter.tagSort)) : 0,
        tag_id: state.filter.tagID ? Number(state.filter.tagID) : 0,
        scene: 1, // 中台固定传1
      };
      api.queryProductList(reqData)
        .then((res) => {
          const code = res.head && res.head.code;
          if (code !== undefined && code !== 0) {
            // 接口业务层报错，请求库会自动处理
            return;
          }

          // 请求成功，处理数据
          const list = res.product_list || [];
          res.products = list.map(item => ({
            ...item,
            material_info: getParseMaterialInfo(item.material_info),
          }));
          commit(types.SET_PRODUCT_LIST, res);
        })
        .finally(() => {
          commit(types.CHANGE_LOADING, { loading: false });
        });
    },

    // 获取一级类目
    async fetchPriCateList({ commit }) {
      let res;
      try {
        res = await request({
          url: 'v1/pcgec/media/ec_basic_server/get_primary_category',
          method: 'post',
          data: {},
        });
      } catch (error) {
      } finally {
        const code = Number(get(res, 'head.code'));
        const msg = get(res, 'head.msg');
        const resultList = get(res, 'primary_category_list') || [];
        if (code === 0) {
          commit(types.SET_PRIMARY_CATELIST, resultList);
        } else {
          Vue.prototype.$tip.error(msg || '获取一级类目失败');
        }
      }
    },
  },
};
